import { useLocale } from "next-intl";
import {
  queryOptions,
  usePrefetchQuery,
  useQuery,
} from "@tanstack/react-query";

import { getLeaguesNew, GetLeaguesNewParams } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "./leaguesNewQueryKeys";

export const createLeaguesNewQueryOptions = (params: GetLeaguesNewParams) => {
  return queryOptions({
    queryKey: [LeaguesNewQueryKeys.LeaguesNew, params],
    queryFn: ({ signal }) => getLeaguesNew({ params, signal }),
  });
};

export const useLeaguesNew = (params: GetLeaguesNewParams = {}) => {
  const lang = useLocale();
  const fullParams = { lang, ...params };

  return useQuery(createLeaguesNewQueryOptions(fullParams));
};

export const usePrefetchLeaguesNew = (params: GetLeaguesNewParams = {}) => {
  const lang = useLocale();
  const fullParams = { lang, ...params };

  return usePrefetchQuery(createLeaguesNewQueryOptions(fullParams));
};

export const usePopularLeagues = (filters: GetLeaguesNewParams = {}) => {
  return useLeaguesNew({ ...filters, popular: true });
};

export const useMostPopularLeagues = (filters: GetLeaguesNewParams = {}) => {
  return useLeaguesNew({ ...filters, mostPopular: true });
};

export const usePrefetchMostPopularLeagues = () => {
  return usePrefetchLeaguesNew({ mostPopular: true });
};

export const usePrefetchPopularLeagues = () => {
  return usePrefetchLeaguesNew({ popular: true });
};
